<script setup lang="ts">
import { useTranslations } from '~/composables/translations';

const { $i18n } = useTranslations('components/homepage/how_it_work');
</script>
<template>
  <div
    class="pa-20px how-it-work-container flex align-items-center justify-center flex-column grid-gap-20px"
  >
    <div class="title">
      {{ $i18n('title') }}
    </div>
    <iframe
      class="video"
      src="https://www.youtube.com/embed/9jMRqTHiDwY"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
    <p class="subtitle text-justify">
      {{ $i18n('subtitle') }}
    </p>
    <div class="flex flex-row--md grid-gap-50px flex-column--sm">
      <img
        src="/assets/images/homepage/3DS_SOLIDWORKS_Logotype_RGB_White.png"
        alt="solidworks"
        class="solidworks-img"
      />
      <img
        src="/assets/images/homepage/3DS_CATIA_Logotype_RGB_White.png"
        alt="catia"
        class="catia-img"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.how-it-work-container {
  background-color: #005685;
  color: white;
}

.video {
  min-width: 50vw;
  max-width: 50vw;
  min-height: 350px;
  max-height: 350px;

  @include variables.for-sm {
    min-width: 70vw;
    max-width: 70vw;
  }

  @include variables.for-xs {
    min-width: 90vw;
    max-width: 90vw;
  }
}
</style>
